module.exports = __webpack_public_path__ + "static/img/nh-university-hr-system.1a7ce3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/nh-university-hr-system.jpg
// module id = 0Gby
// module chunks = 0